import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { api } from '../../services/api'
import './VideoCreate.css'
import { MainLayout } from '../../Layout/MainLayout'

export function CreateVideo() {
    const navigate = useNavigate()
    const { state } = useLocation()
    const courseId = state?.courseId

    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState(false)
    const [error, setError] = useState('')
    const [videoFile, setVideoFile] = useState<File | null>(null)

    const [form, setForm] = useState({
        title: '',
        description: '',
        order: '',
        duration: '',
    })

    function set(field: string, value: string) {
        setForm(prev => ({ ...prev, [field]: value }))
        setError('')
    }

    function validate() {
        if (!courseId) return 'Curso não identificado'
        if (!form.title.trim()) return 'Título é obrigatório'
        if (!videoFile) return 'Arquivo de vídeo é obrigatório'
        return null
    }

    async function handleSubmit() {
        const err = validate()
        if (err) { setError(err); return }

        setLoading(true)
        setError('')
        try {
            const formData = new FormData()
            formData.append('video', videoFile!)
            formData.append('courseId', courseId)
            formData.append('title', form.title)
            formData.append('description', form.description)
            formData.append('order', form.order || '0')
            if (form.duration) formData.append('durationSec', form.duration)

            await api.post('/video', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            })

            setSuccess(true)
            setTimeout(() => navigate('/admin'), 1800)
        } catch (e: any) {
            setError(e.response?.data?.message || 'Erro ao adicionar vídeo')
        } finally {
            setLoading(false)
        }
    }

    if (success) return (
        <MainLayout>
            <div className="cu-success-wrap">
                <div className="cu-success-icon">✓</div>
                <h2 className="serif">Vídeo Adicionado!</h2>
                <p>Redirecionando para o painel...</p>
            </div>
        </MainLayout>
    )

    return (
        <MainLayout>
            <div className="container fade-in">
                <div className="breadcrumb">
                    <a onClick={() => navigate('/admin')}>Admin</a>
                    <span className="sep">›</span>
                    <span>Adicionar Vídeo</span>
                </div>

                <div className="cu-layout">
                    <div className="cu-header">
                        <div className="kicker">Gestão de Vídeos</div>
                        <h1 className="serif">Novo Vídeo</h1>
                        <p>Preencha os dados do vídeo.</p>
                    </div>

                    <div className="cu-form-card">
                        {error && <div className="cu-error">{error}</div>}

                        <div className="cu-section-label">Dados do Vídeo</div>
                        <div className="cu-row">
                            <div className="field" style={{ flex: 2 }}>
                                <label>Título *</label>
                                <input
                                    type="text"
                                    value={form.title}
                                    onChange={e => set('title', e.target.value)}
                                    placeholder="Título do vídeo"
                                    autoFocus
                                />
                            </div>
                            <div className="field" style={{ flex: 1 }}>
                                <label>Duração (segundos)</label>
                                <input
                                    type="number"
                                    value={form.duration}
                                    onChange={e => set('duration', e.target.value)}
                                    placeholder="Ex: 120 = 2 min"
                                    min="0"
                                />
                            </div>
                        </div>

                        <div className="cu-row">
                            <div className="field" style={{ flex: 1 }}>
                                <label>Descrição</label>
                                <input
                                    type="text"
                                    value={form.description}
                                    onChange={e => set('description', e.target.value)}
                                    placeholder="Descrição do vídeo"
                                />
                            </div>

                        </div>

                        <div className="cu-row">
                            <div className="field" style={{ flex: 1 }}>
                                <label>Arquivo de vídeo *</label>
                                <input
                                    type="file"
                                    accept="video/mp4,video/mpeg,video/quicktime,video/x-msvideo"
                                    onChange={e => {
                                        const file = e.target.files?.[0]
                                        if (file) setVideoFile(file)
                                        setError('')
                                    }}
                                />
                                {videoFile && (
                                    <div style={{ fontSize: 12, color: 'var(--teal)', marginTop: 6 }}>
                                        ✓ {videoFile.name} ({(videoFile.size / 1024 / 1024).toFixed(1)} MB)
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="cu-divider" />

                        <div className="cu-actions">
                            <button
                                className="btn btn-ghost"
                                onClick={() => navigate('/admin')}
                                disabled={loading}
                            >
                                Cancelar
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={handleSubmit}
                                disabled={loading}
                            >
                                {loading ? 'Enviando...' : 'Adicionar vídeo →'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </MainLayout>
    )
}